import React from 'react';
var DatePickerContext = /*#__PURE__*/React.createContext(null);
export default DatePickerContext;